import React from 'react';
import Layout from '../components/Layout';

function Stockists() {

    window.scrollTo(0,0);

    return (
        <Layout>
            <div className="flex flex-col items-center justify-center min-h-[calc(100vh-5rem)] p-8">
                <h1 className="text-2xl text-customNavy mb-8 italic">Stockists</h1>
                <p className="text-md text-customNavy mb-4 underline italic">
                    London
                </p>
                <p className="text-md text-customNavy mb-4">
                    <a href="https://www.instagram.com/altastore.ldn" className="text-customNavy no-underline hover:underline">Alta Store</a>
                </p>
                <p className="text-md text-customNavy mb-4">
                    34 Great Windmill Street, London, W1D 7LR
                </p>
            </div>
        </Layout>
    );
}

export default Stockists;
